import { render, staticRenderFns } from "./BrandButton.vue?vue&type=template&id=6a40011c"
import script from "./BrandButton.vue?vue&type=script&lang=js"
export * from "./BrandButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports